<template>
  <article id="return">
    <div class="center" id="error-message" v-if="message">{{message}}</div>
    <div v-show="!message">
      <div id="spinner" class="center">
        <i class="fas fa-circle-notch fa-spin"></i>
      </div>
    </div>
  </article>
</template>
<script>
import axios from "axios";
import { sendAnalytic } from "../utils/analytic";
import * as dataLayer from "../utils/data-layer";

export default {
  data() {
    return {
      message: null
    };
  },
  metaInfo: {
    title: "callback"
  },
  components: {},
  props: { userID: String, env: Object, finnakies: String },
  async created() {},
  async mounted() {
    try {
      const task = await this.$getItem("task");
      const analyticTask = await this.$getItem("analytic_task");
      if (!task) {
        return null;
      }
      if (task.url === "/api/plan/private/save" && analyticTask) {
        sendAnalytic({
          ...analyticTask
        });
        dataLayer.clickCreatePlan({
          plan_type: analyticTask.pl,
          plan_name: analyticTask.pl,
          slot: 1,
          risk_level: analyticTask.ri,
          initial: analyticTask.in,
          purpose: "",
          target_amount: analyticTask.ta,
          timeframe: analyticTask.ti,
          contribution: analyticTask.mo,
          device: analyticTask.de
        });
      }

      await axios({
        headers: {
          "Cache-Control": "no-cache"
        },
        method: task.method,
        url: task.url,
        data: task.data,
        withCredentials: true
      });

      await this.$removeItem("task");
      await this.$removeItem("analytic_task");

      if (task.redirect) {
        window.location = task.redirect;
      } else {
        this.$liff.closeWindow();
      }
    } catch (err) {
      let error = err.message;

      let data = null;
      if (err.response && err.response.data && err.response.data.data) {
        data = err.response.data.data;
      }

      if (data) {
        error = data[0].key;
        for (let i = 1; i < data.length; i++) {
          error += "," + data[i].key;
        }
      }

      this.$router.push({
        name: 500,
        params: {
          userID: this.userID,
          finnakies: this.finnakies,
          error: error
        },
        query: this.$route.query
      });
    }
  },
  methods: {},
  watch: {}
};
</script>
<style lang="scss" scoped>
#return {
  padding: 16px;

  height: 100vh;
  width: 100%;
  text-align: center;
  vertical-align: middle;

  .center {
    position: fixed;
    top: 50%;
    left: 50%;

    /* bring your own prefixes */
    transform: translate(-50%, -50%);
  }

  #error-message {
    color: $color-light-grey;
  }

  #spinner {
    font-size: 3em;
    color: #ffcd00;
  }
}
</style>




